import { lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";

const AIAgent = lazy(() =>
  import("../aiagent/components/voice/AIAgent").then((m) => ({ default: m.AIAgent }))
);

const AIAgentPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <Suspense fallback={null}>
      <AIAgent onClose={handleClose} agentName="Aria" defaultLanguage="kn-IN" />
    </Suspense>
  );
};

export default AIAgentPage;
